(function(){
    angular.module('tmx-app').directive('clearSearchTextOnBlur', ['$timeout',forceSelect]);

    function forceSelect($timeout) {
    
        function postLink(scope, element, attrs, autoComplete) {
            
            // we need to wait for the autocomplete directive
            // to be compiled
            function getInput() {
                return element.find('input').eq(0);
            }
            
            var listener = scope.$watch(getInput, function (input) {
            
                if(input.length) {
                    listener(); // self release
                    var ngModel = input.controller('ngModel');
                    input.on('blur', function () {
                        $timeout(function(){ // check if item selected, if not empty search text
                            if(!autoComplete.scope.selectedItem) {
                                autoComplete.scope.searchText = undefined;
                            }
                        },200); // give it some time think
                    });
                }
            })

        }

        return {
            link: postLink,
            require: 'mdAutocomplete',
            restrict: 'A'
        };
    }
})();